export const COLORS = {
  primaryColor: "#1591D3",
  secondaryColor: "#15D195",
  accentColor: "#1815D1",
};
